
const SEGRegistration = ({
    pageTitle,
    Header,
    Back,
    currentPage,
    handleBackClick,
    subPageTitle,
    PatientRegistrationFormData,
    handleInputChange,
    isNext,
    invalidFields,
    handleZipSearch,
    languageOptions,
    genderOptions,
    FormHeader,
    FormInput,
    TextInput,
    pageRefs,
    setPatientRegistrationFormData,
    DobInput,
    SelectInput,
    ImageConsent,
    Paragraph,
    signatures,
    canvasRefs,
    isEditing,
    updateSignatureData,
    clearSignature,
    toggleEditMode,
    MedicalPortalAccess,
    isDisabled,
    ethnicityOptions,
    raceOptions,
    maritalOptions,
    emergencyRelationshipOptions,
    formattedDate,
    age,
    showPatientSignature,
    setShowPatientSignature,
    showPatientSignaturePage4,
    showPatientSignaturePage5,
    showPatientSignaturePage6,
    setShowPatientSignaturePage4,
    setShowPatientSignaturePage5,
    setShowPatientSignaturePage6,
    AssignmentRelease,
    Signature,
    DisabledTextBox,
    nextLoader,
    ButtonGroup,
    handleAddMember,
    handleFamilyContentChange,
    handleRemoveFamilyMember,
    handleFamilyHistoryChange,
    handleEdit,
    handleNext,
    handlePatientRegistration,
    handleCheckboxChange,
    handleCheckChange,
    FaPlus,
    FaTrash,
    PrivacyConsent,
    FinancialPolicy,
    DynamicCheckbox,
    segLogo,
    SegTitle,
    DOBPickerInput,
    formattingDate,
    CheckboxGroup,
    toggleCheckbox,
    SegFooter,
    SegLogoBanner,
    FamilyDiseases,
    show,
    ABN,
    SegimageConsentForm,
    Head,
    refractionsOptions,
    imagingOptions,
    RadioGroup,
    FamilyMemberConsent,
    SymptomCheckboxGroup,
    optos,
    optosHeader,
    Logo,
    Agree,
    Insurance,
    onFormStateChange
}) => {
    return (
        <>
            <Header pageTitle={pageTitle} />
            <form className="bg-white">
                {(
                    (currentPage > 0 && !show) ||
                    (currentPage !== 7 && show)
                ) && (
                        <Back onClick={handleBackClick} />
                    )}
                {/* Page 1 */}
                {(currentPage === 7 && show) && (

                    <div
                        ref={pageRefs.current[currentPage]}
                        className={`
                            bg-white w-full
                            ${!isNext ? "max-w-6xl" : "w-[1200px] mx-auto"} 
                        `}
                        style={{ transformOrigin: "top left" }}
                    >
                        <SegLogoBanner src={segLogo} />

                        <SegimageConsentForm Paragraph={Paragraph} optos={optos} optosHeader={optosHeader} Logo={Logo} />
                        <div className="border-2 border-gray-300 rounded-md my-2">
                            <p className="bg-gray-200 text-black font-semibold p-2 rounded-t-md">
                                Please choose one of the following:{" "}
                                <span className="text-red-500">*</span>
                            </p>
                            <RadioGroup
                                label=""
                                name="imaging_options"
                                disabled={isNext}
                                selectedValue={PatientRegistrationFormData.imaging_options || ""}
                                onChange={(value) => {
                                    setPatientRegistrationFormData((prev) => ({
                                        ...prev,
                                        imaging_options: value,
                                    }));
                                }}
                                options={imagingOptions}
                            />
                        </div>
                        <div className={`my-4 grid gap-3 ${isNext ? "grid-cols-2" : "grid-cols-1 sm:grid-cols-2"}`}>
                            <FormInput
                                key='printedName'
                                id='printedName'
                                label='Printed Name'
                                type="text"
                                disabled={true}
                                value={PatientRegistrationFormData.firstName + " " + PatientRegistrationFormData.lastName}
                                onChange={handleInputChange}
                                invalid={false}
                                required={false}
                            />
                            <FormInput
                                key='date'
                                id='date'
                                label='Date'
                                type="text"
                                disabled={true}
                                value={formattedDate}
                                onChange={handleInputChange}
                                invalid={false}
                                required={false}
                            />
                        </div>

                        <div className="text-left">

                            <Agree
                                showAgreement={showPatientSignaturePage5}
                                setShowAgreement={setShowPatientSignaturePage5}
                                signatureField={PatientRegistrationFormData.isMinor ? "responsiblePersonSignature" : "patientSignature"}
                                formData={PatientRegistrationFormData}
                                title={"Patient/Responsible Party Signature"}
                            />
                        </div>
                        <div className="my-2">
                            <SegFooter />
                        </div>
                    </div>
                )}
                {currentPage === 0 && (
                    <div
                        ref={pageRefs.current[currentPage]}
                        className={`
                            bg-white w-full
                            ${!isNext ? "max-w-6xl" : "w-[1200px] mx-auto"} 
                        `}
                        style={{ transformOrigin: "top left" }}
                    >
                        <SegLogoBanner src={segLogo} />
                        <div className={`px-5 py-2 ${isNext ? "" : "mx-auto max-w-6xl"}`}>
                            <div className={`my-4 grid gap-3 ${isNext ? "grid-cols-2" : "grid-cols-1 sm:grid-cols-2"}`}>
                                {[
                                    {
                                        id: "firstName",
                                        label: "First Name",
                                        required: true,
                                    },
                                    {
                                        id: "lastName",
                                        label: "Last Name",
                                        required: true,
                                    }
                                ].map(({ id, label, required }) => (
                                    <FormInput
                                        key={id}
                                        id={id}
                                        label={label}
                                        type="text"
                                        disabled={isNext}
                                        value={PatientRegistrationFormData[id]}
                                        onChange={handleInputChange}
                                        invalid={invalidFields.includes(label) && !PatientRegistrationFormData[id]}
                                        required={required}
                                    />
                                ))}
                            </div>

                            <div className={`my-4 grid gap-3 ${isNext ? "grid-cols-2" : "grid-cols-1 sm:grid-cols-2"}`}>
                                <DobInput
                                    value={PatientRegistrationFormData.dob}
                                    onChange={(val) =>
                                        setPatientRegistrationFormData((prev) => ({
                                            ...prev,
                                            dob: val || "",
                                        }))
                                    }
                                    invalid={invalidFields.includes("DOB")}
                                />
                                <SelectInput
                                    id="race"
                                    label="Race"
                                    options={raceOptions}
                                    value={PatientRegistrationFormData.race}
                                    onChange={(e) =>
                                        setPatientRegistrationFormData((prev) => ({
                                            ...prev,
                                            race: e.target.value,
                                        }))
                                    }
                                    disabled={isNext}
                                    invalid={invalidFields.includes("race")}
                                    errorMessage="Please select a race."
                                />


                            </div>

                            <div className={`my-4 grid gap-3 ${isNext ? "grid-cols-2" : "grid-cols-1 sm:grid-cols-2"}`}>
                                <FormInput
                                    key="address"
                                    id="address"
                                    label="Address"
                                    type="text"
                                    disabled={isNext}
                                    value={PatientRegistrationFormData.address}
                                    onChange={handleInputChange}
                                    invalid={invalidFields.includes("Address") && !PatientRegistrationFormData.address}
                                    required={true}
                                />

                                <SelectInput
                                    id="gender"
                                    label="Gender"
                                    options={genderOptions}
                                    value={PatientRegistrationFormData.gender}
                                    onChange={(e) =>
                                        setPatientRegistrationFormData((prev) => ({
                                            ...prev,
                                            gender: e.target.value,
                                        }))
                                    }
                                    disabled={nextLoader}
                                    invalid={invalidFields.includes("Gender") && !PatientRegistrationFormData.gender}
                                    errorMessage="Please select a gender."
                                    required={true}
                                />

                            </div>
                            <div className="my-4 overflow-x-auto">
                                <div className="grid grid-cols-[auto_1fr_auto_1fr_auto_1fr_auto_1fr] gap-6 items-center">

                                    {/* City */}
                                    <label className="text-sm font-medium text-gray-600 text-right whitespace-nowrap">
                                        City
                                    </label>
                                    <div className="px-3 py-2 bg-slate-100 rounded-md text-black font-medium min-h-[42px] flex items-center">
                                        {PatientRegistrationFormData.city || "-"}
                                    </div>

                                    {/* State */}
                                    <label className="text-sm font-medium text-gray-600 text-right whitespace-nowrap">
                                        State
                                    </label>
                                    <div className="px-3 py-2 bg-slate-100 rounded-md text-black font-medium min-h-[42px] flex items-center">
                                        {PatientRegistrationFormData.state || "-"}
                                    </div>

                                    {/* Zip */}
                                    <label className="text-sm font-medium text-gray-600 text-right whitespace-nowrap">
                                        Zip{" "}
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <FormInput
                                        id="zip"
                                        type="text"
                                        disabled={nextLoader}
                                        value={PatientRegistrationFormData.zip}
                                        onChange={handleInputChange}
                                        invalid={invalidFields.includes("zip") && !PatientRegistrationFormData.zip}
                                        required
                                        onZipSearch={handleZipSearch}
                                    />

                                    {/* Age */}
                                    <label className="text-sm font-medium text-gray-600 text-right whitespace-nowrap">
                                        Age
                                    </label>
                                    <div className="px-3 py-2 bg-slate-100 rounded-md text-black font-medium min-h-[42px] flex items-center">
                                        {PatientRegistrationFormData.age || "-"}
                                    </div>

                                </div>
                            </div>


                            <div className={`my-4 grid gap-3 ${isNext ? "grid-cols-2" : "grid-cols-1 sm:grid-cols-2"}`}>
                                <FormInput
                                    key="homephone"
                                    id="homephone"
                                    label="Home Phone"
                                    type="number"
                                    disabled={isNext}
                                    value={PatientRegistrationFormData["homephone"]}
                                    onChange={handleInputChange}
                                    invalid={invalidFields.includes("homephone") && !PatientRegistrationFormData["homephone"]}
                                    required={false}
                                />
                                <SelectInput
                                    id="ethnicity"
                                    label="Ethnicity"
                                    options={ethnicityOptions}
                                    value={PatientRegistrationFormData.ethnicity}
                                    onChange={(e) =>
                                        setPatientRegistrationFormData((prev) => ({
                                            ...prev,
                                            ethnicity: e.target.value,
                                        }))
                                    }
                                    disabled={isNext}
                                    invalid={invalidFields.includes("ethnicity")}
                                />


                            </div>
                            <Paragraph>We may use your phone number for appointment reminders and care-related communication.</Paragraph>


                            <div className={`my-4 grid gap-3 ${isNext ? "grid-cols-2" : "grid-cols-1 sm:grid-cols-2"}`}>

                                <FormInput
                                    key="cellphone"
                                    id="cellphone"
                                    label="Cell Phone"
                                    type="number"
                                    disabled={isNext}
                                    value={PatientRegistrationFormData["cellphone"]}
                                    onChange={handleInputChange}
                                    invalid={invalidFields.includes("Cell Phone") && !PatientRegistrationFormData["cellphone"]}
                                    required={true}
                                />
                                {/* Preferred Language */}
                                <SelectInput
                                    id="preferredLanguage"
                                    label="Preferred Language"
                                    options={languageOptions}
                                    value={PatientRegistrationFormData.language}
                                    onChange={(e) =>
                                        setPatientRegistrationFormData((prev) => ({
                                            ...prev,
                                            language: e.target.value,
                                        }))
                                    }
                                    disabled={isNext}
                                    invalid={invalidFields.includes("preferredLanguage") && !PatientRegistrationFormData.language}
                                    errorMessage="Please select a language."
                                />
                            </div>
                            <Paragraph>We use your email to send important information related to your care, including appointment confirmations, forms, and follow-up instructions.</Paragraph>


                            <div className={`my-4 grid gap-3 ${isNext ? "grid-cols-2" : "grid-cols-1 sm:grid-cols-2"}`}>
                                {/* email*/}

                                <FormInput
                                    key='email'
                                    id='email'
                                    label='Email'
                                    type="text"
                                    disabled={isNext}
                                    value={PatientRegistrationFormData['email']}
                                    onChange={handleInputChange}
                                    invalid={invalidFields.includes('Email') && !PatientRegistrationFormData['email']}
                                    required={false}
                                />
                                <SelectInput
                                    id="maritalStatus"
                                    label="Marital Status"
                                    options={maritalOptions}
                                    value={PatientRegistrationFormData.maritalStatus}
                                    onChange={(e) =>
                                        setPatientRegistrationFormData((prev) => ({
                                            ...prev,
                                            maritalStatus: e.target.value,
                                        }))
                                    }
                                    disabled={isDisabled}
                                    invalid={invalidFields.includes("maritalStatus")}
                                    errorMessage="Please select a marital status."
                                />

                            </div>
                            {
                                Boolean(PatientRegistrationFormData?.email?.trim()) && (
                                    <div className="text-sm text-muted-foreground mt-1 mb-2 gap-2 flex-row">
                                        <DynamicCheckbox
                                            label="Yes, I would like to receive occasional updates from Southern Eye Group, including helpful eye care information, new services, and practice updates. I understand I can unsubscribe at any time."
                                            fieldName="emailConsent"
                                            id="emailConsent"
                                            isChecked={PatientRegistrationFormData.emailConsent}
                                            onChange={handleCheckChange}
                                            isDisabled={nextLoader}
                                            showError={invalidFields.includes("emailConsent")}
                                        />
                                    </div>
                                )
                            }
                            <div className={`my-4 grid gap-3 ${isNext ? "grid-cols-2" : "grid-cols-1 sm:grid-cols-2"}`}>
                                <FormInput
                                    key="hear"
                                    id="hear"
                                    label="How did you hear about us?"
                                    type="text"
                                    disabled={isNext}
                                    value={PatientRegistrationFormData["hear"]}
                                    onChange={handleInputChange}
                                    invalid={invalidFields.includes("How did you hear about us?")}
                                    required={false}
                                />
                                {/* Portal */}
                                <MedicalPortalAccess
                                    id="portal"
                                    label="Would you like to have access to your Medical Records / Portal?"
                                    portalValue={PatientRegistrationFormData.portal}
                                    onChange={handleInputChange}
                                    isDisabled={isNext}
                                />
                            </div>


                        </div>
                    </div>
                )}
                {/* Page 2 */}
                {currentPage === 1 && (
                    <div
                        ref={pageRefs.current[currentPage]}
                        className={`
                            bg-white w-full
                            ${!isNext ? "max-w-6xl" : "w-[1200px] mx-auto"} 
                        `}
                        style={{ transformOrigin: "top left" }}
                    >
                        <div className={`px-5 py-2 ${isNext ? "" : "mx-auto max-w-6xl"}`}>
                            <div className={`my-4 grid gap-3 ${isNext ? "grid-cols-2" : "grid-cols-1 sm:grid-cols-2"}`}>
                                {/* referred by */}

                                <FormInput
                                    key="referredBy"
                                    id="referredBy"
                                    label="Referred By"
                                    type="text"
                                    disabled={isNext}
                                    value={PatientRegistrationFormData["referredBy"]}
                                    onChange={handleInputChange}
                                    invalid={invalidFields.includes("Referred By")}
                                    required={false}
                                />

                                {/* family doctor */}
                                <FormInput
                                    key="primary_doctor"
                                    id="primary_doctor"
                                    label="Primary Care Doctor"
                                    type="text"
                                    disabled={isNext}
                                    value={PatientRegistrationFormData["primary_doctor"]}
                                    onChange={handleInputChange}
                                    invalid={invalidFields.includes("Primary Doctor")}
                                    required={false}
                                />

                            </div>

                            <div className={`my-4 grid gap-3 ${isNext ? "grid-cols-2" : "grid-cols-1 sm:grid-cols-2"}`}>
                                {/* ssn*/}

                                <FormInput
                                    key="ssn"
                                    id="ssn"
                                    label="SSN"
                                    type="text"
                                    disabled={isNext}
                                    value={PatientRegistrationFormData["ssn"]}
                                    onChange={handleInputChange}
                                    invalid={invalidFields.includes("ssn")}
                                    required={false}
                                />



                            </div>

                            <div className="text-sm text-muted-foreground mt-1 mb-2 gap-4 flex-row">


                                {/* reminderPhone */}
                                <DynamicCheckbox
                                    label="Yes, I agree to receive occasional text messages from Southern Eye Group about updates, services, and events. Message and data rates may apply. Message frequency varies. I understand that I can opt-out at any time."
                                    fieldName="consentToText"
                                    id="consentToText"
                                    isChecked={PatientRegistrationFormData.consentToText}
                                    onChange={handleCheckChange}
                                    isDisabled={isNext}
                                    showError={invalidFields.includes("consentToText")}
                                />
                            </div>

                            <div className={`my-4 grid gap-3 ${isNext ? "grid-cols-2" : "grid-cols-1 sm:grid-cols-2"}`}>
                                <FormInput
                                    key="employee"
                                    id="employee"
                                    label="Are you employed? If yes, where?"
                                    type="text"
                                    disabled={isNext}
                                    break_word={true}
                                    value={PatientRegistrationFormData["employee"]}
                                    onChange={handleInputChange}
                                    invalid={invalidFields.includes("Are you employed? If yes, where?")}
                                    required={false}
                                />


                                <DynamicCheckbox
                                    label="No Retired"
                                    fieldName="retired"
                                    id="retired"
                                    isChecked={PatientRegistrationFormData.retired}
                                    onChange={handleCheckChange}
                                    isDisabled={isNext}
                                    showError={invalidFields.includes("retired")}
                                />

                            </div>


                            <div>
                                <label className="block text-base font-medium text-black w-full md:w-1/4">
                                    In Case Of Emergency Notify
                                </label>
                            </div>

                            <div className={`my-4 grid gap-3 ${isNext ? "grid-cols-2" : "grid-cols-1 sm:grid-cols-2"}`}>

                                <FormInput
                                    key="emergencyName"
                                    id="emergencyName"
                                    label="Name"
                                    type="text"
                                    disabled={isNext}
                                    value={PatientRegistrationFormData["emergencyName"]}
                                    onChange={handleInputChange}
                                    invalid={invalidFields.includes("Emergency Name") && !PatientRegistrationFormData["emergencyName"]}
                                    required={false}
                                />

                                <SelectInput
                                    id="emergencyRelationship"
                                    label="Relationship"
                                    options={emergencyRelationshipOptions}
                                    value={PatientRegistrationFormData.emergencyRelationship}
                                    onChange={(e) =>
                                        setPatientRegistrationFormData((prev) => ({
                                            ...prev,
                                            emergencyRelationship: e.target.value,
                                        }))
                                    }
                                    disabled={isNext}
                                    invalid={invalidFields.includes("Emergency Relationship")}
                                    errorMessage="Please select a emergency relationship."
                                />
                            </div>

                            <div className={`my-4 grid gap-3 ${isNext ? "grid-cols-2" : "grid-cols-1 sm:grid-cols-2"}`}>
                                <FormInput
                                    key="emergencyPhone"
                                    id="emergencyPhone"
                                    label='Phone'
                                    type="number"
                                    disabled={isNext}
                                    value={PatientRegistrationFormData["emergencyPhone"]}
                                    onChange={handleInputChange}
                                    invalid={invalidFields.includes('Emergency Phone') && !PatientRegistrationFormData["emergencyPhone"]}
                                    required={false}
                                />
                            </div>


                            <h2 className="font-semibold text-lg mb-2">Insurance Information</h2>

                            {/* <div
                                className={`
                                    grid
                                    ${isNext ? "grid-cols-2" : "grid-cols-1 md:grid-cols-2"}
                                    gap-6
                                `}
                            >                                {[
                                {
                                    id: "primary_company",
                                    label: "Primary Insurance Co",
                                    placeholder: "Primary Insurance Co",
                                    disabled: isNext,
                                },
                                {
                                    id: "primary_holdername",
                                    label: "Policy Holder Name",
                                    placeholder: "Policy Holder Name",
                                    disabled: isNext,
                                },
                                {
                                    id: "primary_policy",
                                    label: "Policy #",
                                    placeholder: "Policy #",
                                    disabled: isNext,
                                },
                                {
                                    id: "primary_dob",
                                    label: "Policy Holder DOB",
                                    placeholder: "MM/DD/YYYY",
                                    disabled: true,
                                    value:
                                        PatientRegistrationFormData.insurance_data.primary_company
                                            ? PatientRegistrationFormData.dob
                                            : "",
                                },
                                {
                                    id: "secondary_company",
                                    label: "Secondary Insurance Co",
                                    placeholder: "Secondary Insurance Co",
                                    disabled: isNext,
                                },
                                {
                                    id: "secondary_holdername",
                                    label: "Policy Holder Name",
                                    placeholder: "Policy Holder Name",
                                    disabled: isNext,
                                },
                                {
                                    id: "secondary_policy",
                                    label: "Policy #",
                                    placeholder: "Policy #",
                                    disabled: isNext,
                                },
                                {
                                    id: "secondary_dob",
                                    label: "Policy Holder DOB",
                                    placeholder: "MM/DD/YYYY",
                                    disabled: true,
                                    value:
                                        PatientRegistrationFormData.insurance_data.secondary_company
                                            ? PatientRegistrationFormData.dob
                                            : "",
                                },
                            ].map(({ id, label, placeholder, disabled, value }) => (
                                <FormInput
                                    key={id}
                                    id={id}
                                    label={label}
                                    labelPosition="top"
                                    value={
                                        value ??
                                        PatientRegistrationFormData.insurance_data[id]
                                    }
                                    onChange={(e) =>
                                        handleCheckboxChange("insurance_data", id, e.target.value)
                                    }
                                    disabled={disabled}
                                    placeholder={placeholder}
                                />
                            ))}
                            </div>

                            <div
                                className={`
                                    grid
                                    ${isNext ? "grid-cols-2" : "grid-cols-1 md:grid-cols-2"}
                                    gap-6
                                `}
                            >                                {[
                                {
                                    id: "vision_insurance",
                                    label: "Vision Insurance Co",
                                    placeholder: "Vision Insurance Co",
                                    disabled: isNext,
                                },
                                {
                                    id: "vision_policy_holder_name",
                                    label: "Policy Holder Name",
                                    placeholder: "Policy Holder Name",
                                    disabled: isNext,
                                },
                                {
                                    id: "ssn_last_4_digits",
                                    label: "Last 4 Digits of Policy Holder SSN",
                                    placeholder: "Last 4 Digits of Policy Holder SSN",
                                    disabled: isNext,
                                },
                                {
                                    id: "vision_dob",
                                    label: "Policy Holder DOB",
                                    placeholder: "MM/DD/YYYY",
                                    disabled: true,
                                    value:
                                        PatientRegistrationFormData.vision.vision_dob
                                            ? PatientRegistrationFormData.dob
                                            : "",
                                }
                            ].map(({ id, label, placeholder, disabled, value }) => (
                                <FormInput
                                    key={id}
                                    id={id}
                                    label={label}
                                    labelPosition="top"
                                    value={
                                        value ??
                                        PatientRegistrationFormData.vision[id]
                                    }
                                    onChange={(e) =>
                                        handleCheckboxChange("vision", id, e.target.value)
                                    }
                                    break_word={true}
                                    disabled={disabled}
                                    placeholder={placeholder}
                                />
                            ))}
                            </div> */}

                            <Insurance
                                insuranceData={PatientRegistrationFormData.insurance_data}
                                onInsurancesChange={(updatedInsurances) => {
                                    setPatientRegistrationFormData(prev => ({
                                        ...prev,
                                        insurance_data: updatedInsurances
                                    }));
                                }}
                                onFormStateChange={onFormStateChange}
                                key="insurance-component"
                                isNext = {isNext}
                            />
                        </div>
                    </div>
                )}
                {/* Page 3 */}
                {currentPage === 2 && (
                    <div
                        ref={pageRefs.current[currentPage]}
                        className={`
                            bg-white w-full
                            ${!isNext ? "max-w-6xl" : "w-[1200px] mx-auto"} 
                        `}
                        style={{ transformOrigin: "top left" }}
                    >
                        <div className="px-4  mx-10 py-2">
                            <SegTitle title="Responsible Party" />
                            <AssignmentRelease />
                            <div className={`px-5 py-2 ${isNext ? "" : "mx-auto max-w-6xl"}`}>                            {/* Permissions Section */}
                                <FamilyMemberConsent
                                    familyMembers={PatientRegistrationFormData.familyMembers}
                                    handleFamilyChange={handleFamilyContentChange}
                                    handleAddMember={handleAddMember}
                                    handleRemoveFamilyMember={handleRemoveFamilyMember}
                                    DOBPickerComponent={DOBPickerInput} // pass your component
                                    fileUpload={isNext}
                                    nextLoader={nextLoader}
                                    FaTrash={FaTrash}
                                    FaPlus={FaPlus}
                                    title={'Southern Eye Group'}
                                />
                            </div>



                            <div className="w-full rounded-lg bg-white p-4 grid grid-cols-2 items-center gap-4">
                                {/* Left side: Date */}

                                <div className="text-left">
                                    <Agree
                                        showAgreement={showPatientSignaturePage6}
                                        setShowAgreement={setShowPatientSignaturePage6}
                                        signatureField={PatientRegistrationFormData.isMinor ? "responsiblePersonSignature" : "patientSignature"}
                                        formData={PatientRegistrationFormData}
                                        title={"Patient/Responsible Party Signature"}
                                    />
                                </div>

                                {/* Right side: Signature */}
                                <div className="text-right">
                                    {formattedDate}
                                </div>
                            </div>

                            {
                                (age >= 18 && age <= 50) &&
                                (
                                    <div className=" bg-white mx-auto">
                                        <label className="block font-bold mb-4">
                                            Are you interested in Laser Vision Correction / LASIK?{" "}
                                            <span className="text-red-500">*</span>
                                        </label>
                                        {Object.keys(PatientRegistrationFormData.lasik).map((key) => (
                                            <div key={key} className="flex space-x-3 mb-2">
                                                <input
                                                    type="checkbox"
                                                    id={key}
                                                    disabled={isNext}
                                                    checked={PatientRegistrationFormData.lasik[key] === true}
                                                    onChange={() => handleCheckboxChange("lasik", key, !PatientRegistrationFormData.lasik[key])}
                                                    className="form-checkbox h-5 w-5 text-blue-600 border-gray-300 rounded"
                                                />
                                                <label htmlFor={key} className="text-black font-medium">{key}</label>
                                            </div>
                                        ))}
                                    </div>
                                )
                            }


                        </div>
                    </div>
                )}
                {/* Page 4 */}
                {currentPage === 3 && (
                    <div
                        ref={pageRefs.current[currentPage]}
                        className={`
                            bg-white w-full
                            ${!isNext ? "max-w-6xl" : "w-[1200px] mx-auto"} 
                        `}
                        style={{ transformOrigin: "top left" }}
                    >
                        <div className={`px-5 py-2 ${isNext ? "" : "mx-auto max-w-6xl"}`}>
                            <SegTitle title="Medical Health Questionnaire" />
                            <div className="w-full rounded-lg bg-white p-4 border border-gray-200 space-y-2">
                                {/* First line: Name, Sex, DOB */}
                                <div className="flex flex-wrap gap-4">
                                    <p><span className="font-semibold">Name:</span> {PatientRegistrationFormData.firstName} {PatientRegistrationFormData.lastName}</p>
                                    <p><span className="font-semibold">Sex:</span> {PatientRegistrationFormData.gender}</p>
                                    <p><span className="font-semibold">DOB:</span> {PatientRegistrationFormData.dob}</p>
                                </div>

                                {/* Second line: Address, Phone */}
                                <div className="flex flex-wrap gap-4">
                                    <p><span className="font-semibold">Address:</span> {PatientRegistrationFormData.address}</p>
                                    <p><span className="font-semibold">Phone:</span> {PatientRegistrationFormData.cellphone}</p>
                                </div>
                            </div>

                            <SegTitle title="If this is your first visit, please complete" />
                            {/* Medication */}
                            <TextInput
                                id="reason"
                                label="What brings you in to see us?"
                                value={PatientRegistrationFormData.reason}
                                onChange={handleInputChange}
                                disabled={isNext}
                                invalid={invalidFields.includes("reason") && !PatientRegistrationFormData.reason}
                            />

                            <div className="mb-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                                {/* Last Visit Date */}
                                <DOBPickerInput
                                    id="last_visit_date"
                                    label="Date of Last Eye Exam"
                                    value={PatientRegistrationFormData.last_visit_date}
                                    onChange={(date) => {
                                        setPatientRegistrationFormData((prev) => ({
                                            ...prev,
                                            last_visit_date: formattingDate(date) || "",
                                        }));
                                    }}
                                    disabled={isNext}
                                    invalid={invalidFields.includes("last_visit_date")}
                                />
                                <FormInput
                                    key="location"
                                    id="location"
                                    label="Location"
                                    type="text"
                                    disabled={isNext}
                                    value={PatientRegistrationFormData.location}
                                    onChange={handleInputChange}
                                    invalid={invalidFields.includes("Location")}
                                    required={false}
                                />
                            </div>

                            <div className="mb-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                                <FormInput
                                    key="hear"
                                    id="hear"
                                    label="How did you hear about us?"
                                    type="text"
                                    disabled={true}
                                    break_word={true}
                                    value={PatientRegistrationFormData["hear"]}
                                    onChange={handleInputChange}
                                    invalid={invalidFields.includes("How did you hear about us?")}
                                    required={false}
                                />
                                <FormInput
                                    key="primary_doctor"
                                    id="primary_doctor"
                                    label="Primary Care Doctor"
                                    type="text"
                                    disabled={true}
                                    value={PatientRegistrationFormData["primary_doctor"]}
                                    onChange={handleInputChange}
                                    invalid={invalidFields.includes("Primary Doctor")}
                                    required={false}
                                />
                            </div>
                            <div className="mb-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                                <FormInput
                                    key="pharmacy"
                                    id="pharmacy"
                                    label="Pharmacy"
                                    type="text"
                                    disabled={isNext}
                                    value={PatientRegistrationFormData["pharmacy"]}
                                    onChange={handleInputChange}
                                    invalid={invalidFields.includes("Pharmacy")}
                                    required={false}
                                />
                                <FormInput
                                    key="pharm_location"
                                    id="pharm_location"
                                    label="Pharmacy Location"
                                    type="text"
                                    disabled={isNext}
                                    value={PatientRegistrationFormData["pharm_location"]}
                                    onChange={handleInputChange}
                                    invalid={invalidFields.includes("Pharmacy Location")}
                                    required={false}
                                />
                            </div>


                            <CheckboxGroup
                                segMeds={PatientRegistrationFormData.seg_meds}
                                label="Are you currently taking"
                                onChange={(med, value) =>
                                    setPatientRegistrationFormData((prev) => ({
                                        ...prev,
                                        seg_meds: {
                                            ...prev.seg_meds,
                                            [med]: value
                                        }
                                    }))
                                }
                            />

                            <CheckboxGroup
                                segMeds={PatientRegistrationFormData.procedures}
                                label="Check if you have ever had any of the following eye procedures"
                                onChange={(procedure, value) =>
                                    setPatientRegistrationFormData((prev) => ({
                                        ...prev,
                                        procedures: {
                                            ...prev.procedures,
                                            [procedure]: value
                                        }
                                    }))
                                }
                            />

                            {PatientRegistrationFormData.procedures['Other'] && (
                                <div className="mb-4 grid grid-cols-1 sm:grid-cols-1 gap-4">
                                    <FormInput
                                        key="other_procedures"
                                        id="other_procedures"
                                        label="Please specify other procedures"
                                        type="text"
                                        disabled={isNext}
                                        value={PatientRegistrationFormData.other_procedures}
                                        onChange={handleInputChange}
                                        invalid={invalidFields.includes("other_procedures") && !PatientRegistrationFormData.other_procedures}
                                        required={true}
                                    />
                                </div>
                            )}


                            {/* Medication */}
                            <TextInput
                                id="medication"
                                label="Current Medications"
                                value={PatientRegistrationFormData.medication}
                                onChange={handleInputChange}
                                disabled={isNext}
                                invalid={invalidFields.includes("medication") && !PatientRegistrationFormData.medication}
                            />
                            {/* Allergies */}
                            <TextInput
                                id="allergies"
                                label="Allergies To Medications"
                                value={PatientRegistrationFormData.allergies}
                                onChange={handleInputChange}
                                disabled={isNext}
                                invalid={invalidFields.includes("allergies") && !PatientRegistrationFormData.allergies}
                            />

                            {/* illness */}
                            <TextInput
                                id="illnesses"
                                label="List all current and previous illnesses, injuries, and surgeries"
                                value={PatientRegistrationFormData.illnesses}
                                onChange={handleInputChange}
                                disabled={isNext}
                                invalid={invalidFields.includes("illnesses") && !PatientRegistrationFormData.illnesses}
                            />

                        </div>
                    </div>
                )}
                {/* Page 5 */}
                {currentPage === 4 && (
                    <div
                        ref={pageRefs.current[currentPage]}
                        className={`
                            bg-white w-full
                            ${!isNext ? "max-w-6xl" : "w-[1200px] mx-auto"} 
                        `}
                        style={{ transformOrigin: "top left" }}
                    >
                        <div className={`px-5 py-2 ${isNext ? "" : "mx-auto max-w-6xl"}`}>
                            <div className="mb-4">
                                <label className="block text-base font-medium text-black col-span-1">
                                    Please check any of the conditions you have today:
                                </label>
                                {Object.keys(PatientRegistrationFormData.conditions).map((category) => (
                                    <div key={category} className="mb-1">
                                        <h2 className="text-md font-semibold mb-2">{category}</h2>
                                        <div className="grid grid-cols-4 gap-2">
                                            {PatientRegistrationFormData.conditions[category].map((item, index) => (
                                                <label
                                                    key={`${category}-${index}`}
                                                    className="flex items-center space-x-2 p-2 border rounded hover:bg-gray-50 cursor-pointer"
                                                >
                                                    <input
                                                        type="checkbox"
                                                        checked={item.checked}
                                                        onChange={(e) => {
                                                            setPatientRegistrationFormData((prev) => ({
                                                                ...prev,
                                                                conditions: {
                                                                    ...prev.conditions,
                                                                    [category]: prev.conditions[category].map((symptom, i) =>
                                                                        i === index
                                                                            ? { ...symptom, checked: e.target.checked }
                                                                            : symptom
                                                                    ),
                                                                },
                                                            }));
                                                        }}
                                                        className="form-checkbox h-3 w-3 text-blue-600"
                                                    />
                                                    <span>{item.name}</span>
                                                </label>
                                            ))}
                                        </div>
                                    </div>
                                ))}

                            </div>

                            <FamilyDiseases
                                familyDiseases={PatientRegistrationFormData.familyDiseases}
                                handleFamilyHistoryChange={handleFamilyHistoryChange}
                                isNext={isNext}
                            />
                            {/* Other Important Information */}
                            <TextInput
                                id="other_important_information"
                                label="Other"
                                value={PatientRegistrationFormData.other_important_information}
                                onChange={handleInputChange}
                                disabled={isDisabled}
                                invalid={invalidFields.includes("other_important_information") && !PatientRegistrationFormData.other_important_information}
                            />
                            <div>
                                {/* Do you smoke? question */}
                                <div className="flex items-center gap-4 mb-4">
                                    <label className="text-base font-medium text-black">
                                        Do you smoke?
                                    </label>

                                    {/* Yes/No Checkboxes */}
                                    <div className="flex items-center gap-4">
                                        <input
                                            type="checkbox"
                                            id="smoke-yes"
                                            checked={PatientRegistrationFormData.smoker === true}
                                            onChange={() => {
                                                handleCheckChange("smoker", true);
                                                setPatientRegistrationFormData((prev) => ({
                                                    ...prev,
                                                    smokedInPast: "", // Clear packs per day when smoker is checked
                                                }));
                                            }}
                                            disabled={isNext}
                                            className="form-radio font-medium h-5 w-5 border-gray-300 checked:bg-blue-600"
                                        />
                                        <label
                                            htmlFor="smoke-yes"
                                            className="text-base font-medium text-black"
                                        >
                                            Yes
                                        </label>

                                        <input
                                            type="checkbox"
                                            id="smoke-no"
                                            checked={PatientRegistrationFormData.smoker === false}
                                            onChange={() => {
                                                setPatientRegistrationFormData((prev) => ({
                                                    ...prev,
                                                    packsPerDay: "", // Assign the value directly
                                                }));
                                                handleCheckChange("smoker", false);
                                            }}
                                            disabled={isNext}
                                            className="form-radio font-medium h-5 w-5 border-gray-300 checked:bg-blue-600"
                                        />
                                        <label htmlFor="smoke-no" className="text-base font-medium text-black">
                                            No
                                        </label>

                                        <label
                                            htmlFor="packs-per-day"
                                            className="text-base font-medium text-black"
                                        >
                                            Packs per day:
                                        </label>
                                        <input
                                            id="packsPerDay"
                                            type="number"
                                            min="0"
                                            value={PatientRegistrationFormData.packsPerDay}
                                            onChange={handleInputChange}
                                            disabled={
                                                isNext ||
                                                PatientRegistrationFormData.smoker === false
                                            }
                                            className="h-8 w-16 px-3 py-2 bg-slate-50 font-medium border-0 border-b-2 border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="flex items-center gap-4 mb-4">
                                <label className="text-base font-medium text-black">
                                    Have you smoked in the past?
                                </label>

                                <div className="flex items-center gap-4">
                                    <input
                                        type="radio"
                                        id="smoked-past-yes"
                                        name="smoked-past"
                                        value="yes"
                                        checked={PatientRegistrationFormData.smokedInPast === true}
                                        onChange={() => handleCheckChange("smokedInPast", true)}
                                        disabled={
                                            isNext || PatientRegistrationFormData.smoker === true
                                        }
                                        className="form-radio h-5 w-5 bg-slate-50 font-medium border-0 border-b-2 border-gray-300  checked:bg-blue-600"
                                    />
                                    <label
                                        htmlFor="smoked-past-yes"
                                        className="text-base font-medium text-black"
                                    >
                                        Yes
                                    </label>

                                    <input
                                        type="radio"
                                        id="smoked-past-no"
                                        name="smoked-past"
                                        value="no"
                                        checked={PatientRegistrationFormData.smokedInPast === false}
                                        onChange={() => handleCheckChange("smokedInPast", false)}
                                        disabled={
                                            isNext || PatientRegistrationFormData.smoker === true
                                        }
                                        className="form-radio h-5 w-5 font-medium border-gray-300 checked:bg-blue-600"
                                    />
                                    <label
                                        htmlFor="smoked-past-no"
                                        className="text-base font-medium text-black"
                                    >
                                        No
                                    </label>
                                </div>
                            </div>

                            <div>
                                <div className="flex items-center gap-4 mb-4">
                                    <label className="text-base font-medium text-black">
                                        Are you currently pregnant?
                                    </label>

                                    {/* Yes/No Radio Buttons */}
                                    <div className="flex items-center gap-4">
                                        <input
                                            type="radio"
                                            id="pregnant-yes"
                                            name="pregnant"
                                            value="yes"
                                            checked={
                                                PatientRegistrationFormData.pregnant === true
                                            }
                                            onChange={() => handleCheckChange("pregnant", true)}
                                            disabled={isNext || PatientRegistrationFormData.gender !== 'F'}
                                            className="form-radio h-5 w-5 font-medium border-gray-300 checked:bg-blue-600"
                                        />
                                        <label
                                            htmlFor="pregnant-yes"
                                            className="text-base font-medium text-black"
                                        >
                                            Yes
                                        </label>

                                        <input
                                            type="radio"
                                            id="pregnant-no"
                                            name="pregnant"
                                            value="no"
                                            checked={
                                                PatientRegistrationFormData.pregnant === false
                                            }
                                            onChange={() => {
                                                setPatientRegistrationFormData((prev) => ({
                                                    ...prev,
                                                    due_date: "", // Assign the value directly
                                                }));
                                                handleCheckChange("pregnant", false);
                                            }}
                                            disabled={isDisabled || PatientRegistrationFormData.gender !== 'F'}
                                            className="form-radio h-5 w-5 font-medium border-gray-300 checked:bg-blue-600"
                                        />
                                        <label
                                            htmlFor="pregnant-no"
                                            className="text-base text-black font-medium"
                                        >
                                            No
                                        </label>

                                        <label
                                            htmlFor="due_date"
                                            className="text-base font-medium text-black"
                                        >
                                            Anticipated Due Date?
                                        </label>
                                        <input
                                            id="due_date"
                                            type="text"
                                            min="0"
                                            value={PatientRegistrationFormData.due_date}
                                            onChange={handleInputChange}
                                            disabled={
                                                isNext ||
                                                PatientRegistrationFormData.pregnant !== true
                                            }
                                            className="h-8 w-16 px-3 py-2 font-medium border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                        />
                                    </div>
                                </div>
                            </div>


                            {/* Do you drive? question */}
                            <div className="flex items-center gap-4 mb-4">
                                <label className="text-base font-medium text-black">
                                    Do you drive?
                                </label>

                                {/* Yes/No Radio Buttons */}
                                <div className="flex items-center gap-4">
                                    <input
                                        type="radio"
                                        id="drive-yes"
                                        name="drive"
                                        value="yes"
                                        checked={PatientRegistrationFormData.doYouDrive === true}
                                        onChange={() => handleCheckChange("doYouDrive", true)}
                                        disabled={isNext}
                                        className="form-radio h-5 w-5 border-gray-300 checked:bg-blue-600"
                                    />
                                    <label htmlFor="drive-yes" className="text-base font-medium text-black">
                                        Yes
                                    </label>

                                    <input
                                        type="radio"
                                        id="drive-no"
                                        name="drive"
                                        value="no"
                                        checked={PatientRegistrationFormData.doYouDrive === false}
                                        onChange={() => handleCheckChange("doYouDrive", false)}
                                        disabled={isNext}
                                        className="form-radio h-5 w-5 border-gray-300 checked:bg-blue-600"
                                    />
                                    <label htmlFor="drive-no" className="text-base font-medium text-black">
                                        No
                                    </label>
                                </div>
                            </div>


                            <Agree
                                showAgreement={showPatientSignaturePage4}
                                setShowAgreement={setShowPatientSignaturePage4}
                                signatureField={PatientRegistrationFormData.isMinor ? "responsiblePersonSignature" : "patientSignature"}
                                formData={PatientRegistrationFormData}
                                title={"Patient/Responsible Party Signature"}
                            />

                            <div className="mb-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                                {/* date*/}

                                <FormInput
                                    key='date'
                                    id='date'
                                    label='Date'
                                    type="text"
                                    disabled={true}
                                    value={formattedDate}
                                    onChange={handleInputChange}
                                    invalid={false}
                                    required={false}
                                />
                            </div>
                        </div>
                    </div>
                )}
                {/* Page 6 */}
                {currentPage === 5 && (
                    <div
                        ref={pageRefs.current[currentPage]}
                        className={`
                            bg-white w-full
                            ${!isNext ? "max-w-6xl" : "w-[1200px] mx-auto"} 
                        `}
                        style={{ transformOrigin: "top left" }}
                    >
                        <div className="px-5 py-2">
                            <SegTitle title="Privacy and Billing Consent form" />
                            <div className="w-full rounded-lg bg-white p-4 border border-gray-200 space-y-2">
                                <div className="flex flex-wrap gap-4">
                                    <p>
                                        <span className="font-semibold">Patient Name:</span>{" "}
                                        {PatientRegistrationFormData.firstName}{" "}
                                        {PatientRegistrationFormData.lastName}
                                    </p>
                                </div>
                            </div>

                            <FinancialPolicy />

                            <div className={`my-4 grid gap-3 ${isNext ? "grid-cols-2" : "grid-cols-1 sm:grid-cols-2"}`}>
                                <div className="w-full rounded-lg bg-white">
                                    {/* Signature Canvas */}


                                    <Agree
                                        showAgreement={showPatientSignaturePage5}
                                        setShowAgreement={setShowPatientSignaturePage5}
                                        signatureField={PatientRegistrationFormData.isMinor ? "responsiblePersonSignature" : "patientSignature"}
                                        formData={PatientRegistrationFormData}
                                        title={"Patient/Responsible Party Signature"}
                                    />
                                </div>

                                <FormInput
                                    key="date"
                                    id="date"
                                    label="Date"
                                    type="text"
                                    disabled={true}
                                    value={formattedDate}
                                    onChange={handleInputChange}
                                    invalid={false}
                                    required={false}
                                />
                            </div>
                        </div>

                        <SegFooter />
                        <br />
                    </div>
                )}

                {/* Page 7 */}
                {(currentPage === 6 && show) && (

                    <div
                        ref={pageRefs.current[currentPage]}
                        className={`
                            bg-white w-full
                            ${!isNext ? "max-w-6xl" : "w-[1200px] mx-auto"} 
                        `}
                        style={{ transformOrigin: "top left" }}
                    >
                        <SegLogoBanner src={segLogo} />
                        <div className="my-2">
                            <Head title={pageTitle} />
                        </div>

                        <ABN />

                        <div className="mb-4 grid grid-cols-1 sm:grid-cols-2 gap-4 my-2">
                            <FormInput
                                key="printedName"
                                id="printedName"
                                label="Printed Name"
                                type="text"
                                disabled={true}
                                value={PatientRegistrationFormData["firstName"] + " " + PatientRegistrationFormData["lastName"]}
                                invalid={invalidFields.includes("Printed Name")}
                            />
                            <FormInput
                                key="formattedDate"
                                id="formattedDate"
                                label="Formatted Date"
                                type="text"
                                disabled={true}
                                value={formattedDate}
                                invalid={invalidFields.includes("Formatted Date")}
                            />
                        </div>


                        <div className={`my-4 grid gap-3 ${isNext ? "grid-cols-2" : "grid-cols-1 sm:grid-cols-2"}`}>
                            <div className="w-full rounded-lg bg-white">
                                {/* Signature Canvas */}
                                <Agree
                                    showAgreement={showPatientSignaturePage5}
                                    setShowAgreement={setShowPatientSignaturePage5}
                                    signatureField={PatientRegistrationFormData.isMinor ? "responsiblePersonSignature" : "patientSignature"}
                                    formData={PatientRegistrationFormData}
                                    title={"Patient/Responsible Party Signature"}
                                />

                            </div>

                        </div>
                        <div className="border-2 border-gray-300 rounded-md my-2">
                            <p className="bg-gray-200 text-black font-semibold p-2 rounded-t-md">
                                Prescription Options {" "}
                                <span className="text-red-500">*</span>
                            </p>
                            <RadioGroup
                                label=""
                                name="refractions"
                                disabled={isNext}
                                selectedValue={PatientRegistrationFormData.refractions || ""}
                                onChange={(value) => {
                                    setPatientRegistrationFormData((prev) => ({
                                        ...prev,
                                        refractions: value,
                                    }));
                                }}
                                options={refractionsOptions}
                                stacked={true}
                            />

                        </div>
                        <div className="my-2">
                            <SegFooter />
                        </div>
                    </div>
                )}
            </form >
            <div className="mt-10">
                <ButtonGroup
                    isDisabled={isDisabled}
                    currentPage={currentPage}
                    handleEdit={handleEdit}
                    handleNext={handleNext}
                    handlePatientRegistration={handlePatientRegistration}
                />
            </div>
        </>
    );
};

export default SEGRegistration;
